import { FC } from 'react';
import { Dialog, ThemeProvider } from '@mui/material'
import { theme } from '../../utils/constants';
import images from '../../assets/images';
// import { QuizData } from '../../pages/Quiz/Quiz';
import './ResultsPopup.scss';

type Options = {
    option_A: string;
    option_B: string;
    option_C?: string;
    option_D?: string;
    option_E?: string;
    option_F?: string;
  }
  
  export type questions = {
    qs_id: string;
    qs_info: string;
    question_id?:string;
    is_correct: string;
    options: Options;
    question: string;
    isCorrectAnswer: boolean;
    chosen_option: string;
  }
  
  export type Students = {
    studentAvatarUrl: string;
    studentId: string;
    studentName: string;
    totalScore: number;
  }

export type QuizData = {
    quizId: string;
    isClassroom: boolean;
    createdAt: string;
    quizTitle: string;
    updatedAt: string;
    questions: questions[];
    status: string;
    totalScore: number;
    totalQuestions: number;
    totalCompletedStudents?: number;
    students: Students[];
    questionsCount: number;
    results: any[];
    feedId : string
  }

interface propsType{
    open: boolean;
    data: QuizData;
    isQuestionBank?: boolean;
    handleClick: (val: string) => void;
}

const ResultsPopup:FC<propsType> = ({ open, data, handleClick, isQuestionBank}) => {

    const { whiteClose, BlueArrow} = images;
    
    return (
        <ThemeProvider theme={theme}>
            <Dialog open={open} classes={{paper: 'paperStyleResults'}} >
                <div className={'ResultdialogMainContainer'}>
                    <div className={data?.totalScore === 0 ? 'zeroScoreContainer' : 'scoreContainer'}>
                        <img src={ whiteClose } onClick={() => handleClick("close")} className='CloseIcon' alt='logoutGif' height={26}/>
                        <div className='youScored'>YOU SCORED</div>  
                        <div className='Score'>{data?.totalScore === 0 ? '0' : `${String(data?.totalScore).padStart(2, '0')}`}</div>
                        <div className='OutOf'>{`OUT OF ${String(data?.totalQuestions).padStart(2, '0')}`}</div>  
                        
                    </div>
                    <div className='ctaActions'>
                        {isQuestionBank && (
                                <div className='statement'>
                                    <div className='greyBox'></div>
                                    <label className='AmazingText'>YOU'RE AMAZING</label>
                                </div>
                        )}
                        {isQuestionBank ? (
                            <div className='viewText' onClick={() => handleClick("view")}>
                                <label className='GoToText'>Go to your</label>
                                <div className='ResultContainer'>
                                    <label className='resultStats'>Result Stats</label>
                                    <img src={ BlueArrow } alt='logoutGif'/>
                                </div>
                            </div>
                        ) : (
                            <div className='viewText' onClick={() => handleClick("view")}>
                                View Result
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
        </ThemeProvider>
    )
}

export default ResultsPopup;
